export default __webpack_public_path__ + "static/media/close-btn.c63439dd.svg";